import React from "react";
import { format } from "date-fns";
import svLocale from "date-fns/locale/sv";
import url from "url";
import Grid from "src/components/UI/Grid/Grid";
import Column from "src/components/UI/Grid/Column";
import ListItemStyles from "src/components/styles/ListItemStyles";
import Box from "src/components/UI/Structure/Box";
import BuyButton from "src/components/Modules/BuyButton";
import LinkStyles from "src/components/styles/LinkStyles";

const EventItem = ({ event, size }) => {
  const {
    acfEventPage: {
      date,
      artist: { title, link, uri },
      location,
      ticket: { status, releaseDate, link: ticketUrl },
    },
  } = event;

  return (
    <ListItemStyles size={size}>
      <Grid
        flexDirection="row"
        flexWrap={["wrap", null, null, "nowrap"]}
        alignItems={["center"]}
        justifyContent={["flex-start", null, null, "space-between"]}
      >
        {/* Date */}
        <Column width={[12 / 12, null, null, 2 / 12]}>
          <div className="list-content list-content--date">
            <Box mb={[2, null, null, 0]}>
              <span>
                {format(new Date(date), "dd MMM yyyy", { locale: svLocale })}
              </span>
            </Box>
          </div>
        </Column>
        {/* Artist */}
        {size !== "small" && (
          <Column width={[12 / 12, null, null, 3 / 12]}>
            <LinkStyles to={link ? url.parse(link).pathname : ""}>
              <div className="list-content list-content--title">
                <span>{title}</span>
              </div>
            </LinkStyles>
          </Column>
        )}
        {/* Venue */}
        <Column width={["auto", null, null, 3 / 12]}>
          <div className="list-content">
            <span>{location.venue}</span>
          </div>
        </Column>
        {/* Location */}
        <Column width={["auto", null, null, 3 / 12]}>
          <div className="list-content">
            <span>
              {location?.city && location.city}
              {location?.country !== "SE" && ` (${location.country})`}
            </span>
          </div>
        </Column>
        {/* Button */}

        <Column width={[12 / 12, null, "188px", null, "188px", "260px"]}>
          <div className="list-content list-content--actions">
            <Box mt={[3, null, null, 0]} width={["auto", null, null, 1]}>
              <BuyButton
                size={size}
                status={status}
                ticketUrl={ticketUrl}
                ticketReleaseDate={releaseDate}
              />
            </Box>
          </div>
        </Column>
      </Grid>
    </ListItemStyles>
  );
};

EventItem.defaultProps = {
  size: "medium",
};

export default EventItem;
